import React, { useEffect, useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import api from '../api';

function AdminLayout() {
  const navigate = useNavigate();
  const [admin, setAdmin] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('liceo_token');
    if (!token) { navigate('/admin/login'); return; }
    api.get('/auth/me').then(r => setAdmin(r.data)).catch(() => {
      localStorage.removeItem('liceo_token');
      navigate('/admin/login');
    });
  }, [navigate]);

  const logout = () => {
    localStorage.removeItem('liceo_token');
    navigate('/admin/login');
  };

  if (!admin) return <div className="loading"><div className="spinner"></div> Cargando...</div>;

  return (
    <div className="admin-layout">
      <aside className="admin-sidebar">
        <div className="admin-sidebar-header">
          <h2>Panel Admin</h2>
          <p>Hola, {admin.name}</p>
        </div>
        <ul className="admin-nav">
          <li><NavLink to="/admin" end><span className="material-icons">dashboard</span> Dashboard</NavLink></li>
          <li><NavLink to="/admin/content"><span className="material-icons">edit_note</span> Contenido</NavLink></li>
          <li><NavLink to="/admin/gallery"><span className="material-icons">photo_library</span> Galería</NavLink></li>
          <li><NavLink to="/admin/messages"><span className="material-icons">mail</span> Mensajes</NavLink></li>
          <li><NavLink to="/admin/logo"><span className="material-icons">image</span> Logo</NavLink></li>
        </ul>
        <div className="admin-sidebar-footer">
          <button onClick={() => navigate('/')}><span className="material-icons">visibility</span> Ver sitio</button>
          <button onClick={logout}><span className="material-icons">logout</span> Cerrar sesión</button>
        </div>
      </aside>
      <main className="admin-main">
        <Outlet />
      </main>
    </div>
  );
}

export default AdminLayout;
